import { AppLanguage } from '@src/common/app-language';
import { jsBridge } from '@src/utils/js-bridge';
import {
    AppLocalStorage,
    HorseRacingLiveSchedule,
    MSLiveSchedule,
    OldAppLocalStorage,
    PreferenceDataEmpty,
    SendPreferenceCRMData,
} from '@src/utils/js-bridge/js-bridge';
import { DeepReadonly } from '@src/utils/type-utils';
import { makeAutoObservable, runInAction } from 'mobx';
import { AppBaseStore } from './app-base-store';
import bettingStrategyStore from './bettingStrategy-store';
// import { mockStorageData } from '@src/utils/js-bridge/mock';
import { Step3Data } from '@src/utils/js-bridge/PRODPreferenceStep3';

export class SettingStore {
    isLoading = true;
    // isCalendarLoading = true;
    error: Error | null = null;
    notFirstTimePreferenceSection = false;
    /** false时跳页面 */
    notFirstTimePreference: string[] = ['false'];
    /** true显示 */
    newUser: string[] = ['false'];
    steps = 1;
    preferencePrefName = '';
    storageData: DeepReadonly<AppLocalStorage | OldAppLocalStorage | PreferenceDataEmpty> = {};
    constructor(private baseStore: AppBaseStore) {
        makeAutoObservable(this, undefined, { deep: false });
    }

    public savePreferenceSetting(preferences: SendPreferenceCRMData, steps?: number) {
        /** 20250110 修订兼容CRM and B&V */
        const preferenceData: any = {
            ...preferences,
            steps: [`${steps}`],
        };

        //  下发数据
        this.storageData = { ...this.storageData, preferenceData };
        this.notFirstTimePreference = preferences?.notFirstTimePreference ?? ['true'];
        console.log('下发给APP数据----', preferenceData);
        jsBridge.appSaveDiscoverPreference(preferenceData);
    }

    /** tips hide */
    public saveNewUser(preferences: SendPreferenceCRMData) {
        const preferenceData = {
            ...preferences,
            newUser: ['false'],
        };
        jsBridge.appSaveDiscoverPreference(preferenceData);
    }

    // public saveSteps(preferences: UserCustomerPreferenceSetting) {
    //     // 兼容app202503月份旧版本旧数据
    //     if (preferences?.step3) {
    //         jsBridge.appSaveDiscoverPreference({
    //             preferences: preferences || undefined,
    //             steps: this.steps,
    //         });
    //     } else {
    //         const preferenceData = {
    //             step1: preferences?.step1,
    //             step2: preferences?.step2,
    //             Horses: preferences?.horses,
    //             Trainers: preferences?.trainers,
    //             Jockeys: preferences?.jockeys,
    //             Music: preferences?.music,
    //             'Personal Interests': preferences?.interests,
    //             'Dinning Preference': preferences?.dining,
    //             notFirstTimePreference: preferences?.notFirstTimePreference,
    //             newUser: ['true'],
    //             steps: [`${this.steps}`],
    //             latestTrackTime: [`${this.storageData?.preferenceData?.latestTrackTime}`],
    //         };
    //         jsBridge.appSaveDiscoverPreference(preferenceData);
    //     }
    // }

    public savePreferencePrefName(n: string) {
        this.preferencePrefName = n;
    }

    /** 第一步请求app 获取数据，同步数据到mobox */
    async loadSettings() {
        try {
            this.isLoading = true;
            // const storageData = await jsBridge.appGetLocalStorageData();

            // 优先尝试使用 appGetLocalStorageDataAsync
            const getAppData:
                | AppLocalStorage
                | OldAppLocalStorage
                | PreferenceDataEmpty
                | undefined
                | any = window.RNDiscoverJsBridge?.appGetLocalStorageDataRequestAsync
                ? await jsBridge.appGetLocalStorageDataAsync()
                : await jsBridge.appGetLocalStorageData();

            const dataConversion = (
                v: AppLocalStorage | OldAppLocalStorage | PreferenceDataEmpty | undefined
            ) => {
                const isEmptyObject = (obj: object) => Object.keys(obj).length === 0;

                const InitPreferenceData = {
                    step1: [],
                    step2: [],
                    Horses: [],
                    Trainers: [],
                    Jockeys: [],
                    Music: [],
                    'Personal Interests': [],
                    'Dinning Preference': [],
                    notFirstTimePreference: ['false'],
                    newUser: ['true'],
                    steps: ['1'],
                    latestTrackTime: [],
                };

                if (
                    v &&
                    (isEmptyObject(v) || (v.preferenceData && isEmptyObject(v.preferenceData)))
                ) {
                    return { ...v, preferenceData: InitPreferenceData };
                }

                const preferenceData = v && v.preferenceData;

                const filterStep3Data = (step3: string[]) => {
                    return {
                        Jockeys: step3.filter((jockey) => Step3Data.jockeysArr.includes(jockey)),
                        Trainers: step3.filter((trainer) =>
                            Step3Data.trainersArr.includes(trainer)
                        ),
                        Horses: step3.filter((horse) => Step3Data.horsesArr.includes(horse)),
                    };
                };

                if (preferenceData && preferenceData.preferences) {
                    const {
                        step1,
                        step2,
                        step3 = [],
                        noFirstTimePreference = true,
                    } = preferenceData.preferences;
                    const { Jockeys, Trainers, Horses } = filterStep3Data(step3);

                    return {
                        ...v,
                        preferenceData: {
                            step1: [`${step1 || ''}`],
                            step2: step2 || [],
                            Jockeys,
                            Trainers,
                            Horses,
                            Music: [],
                            'Personal Interests': [],
                            'Dinning Preference': [],
                            notFirstTimePreference: [`${noFirstTimePreference}`],
                            newUser: [`${preferenceData.newUser || 'false'}`],
                            steps: [`${preferenceData.steps || '1'}`],
                            latestTrackTime: [`${preferenceData.latestTrackTime || ''}`],
                        },
                    };
                } else {
                    return {
                        ...v,
                        preferenceData: {
                            step1: preferenceData?.step1 || [],
                            step2: preferenceData?.step2 || [],
                            Horses: preferenceData?.Horses || [],
                            Trainers: preferenceData?.Trainers || [],
                            Jockeys: preferenceData?.Jockeys || [],
                            Music: preferenceData?.Music || [],
                            'Personal Interests': preferenceData['Personal Interests'] || [],
                            'Dinning Preference': preferenceData['Dinning Preference'] || [],
                            notFirstTimePreference: preferenceData?.notFirstTimePreference || [
                                'false',
                            ],
                            newUser: preferenceData?.newUser || ['true'],
                            steps: preferenceData?.steps || ['1'],
                            latestTrackTime: preferenceData?.latestTrackTime || [],
                        },
                    };
                }
            };

            const InitstorageData = dataConversion(getAppData);

            console.log('获取APPgetAPPLocalStorage-----', InitstorageData);
            if (getAppData) {
                bettingStrategyStore.setBettingDefault(getAppData?.allBettingStrategies ?? true);
            }

            runInAction(() => {
                this.storageData = InitstorageData as DeepReadonly<AppLocalStorage>;
                this._liveSchedule = InitstorageData?.horseRacingLiveSchedule || null;
                this._MsLiveSchedule = InitstorageData?.MSLiveSchedule || null;
                this.notFirstTimePreference = InitstorageData?.preferenceData
                    ?.notFirstTimePreference || ['false'];
                this.newUser = InitstorageData?.preferenceData?.newUser || ['false'];
                this._calendarEventUUIDList = InitstorageData?.calendarEventUUIDList
                    ? InitstorageData?.calendarEventUUIDList
                    : [];
                // this._allBettingStrategies = storageData?.allBettingStrategies ?? true;
            });
        } catch (err) {
            runInAction(() => {
                this.error = err as Error;
                console.error('appGetLocalStorageData error', err);
            });
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }

    private _liveSchedule: HorseRacingLiveSchedule | null = null;
    public get liveSchedule(): HorseRacingLiveSchedule | null {
        if (this._liveSchedule) {
            // deep clone a live shcedule to prevent the original schedule data being changed when filtering
            const schedule: HorseRacingLiveSchedule = structuredClone(this._liveSchedule);
            schedule.racingScheduleList = schedule.racingScheduleList.filter((sc) => {
                if (this.baseStore.locale === AppLanguage.zh_hk) {
                    return sc.languageCode === 'hk';
                } else {
                    return sc.languageCode === 'en';
                }
            });
            return schedule;
        }
        return null;
    }

    private _MsLiveSchedule: MSLiveSchedule | null = null;
    public get MsLiveSchedule(): MSLiveSchedule | null {
        if (this._MsLiveSchedule) {
            // deep clone a live shcedule to prevent the original schedule data being changed when filtering
            const schedule: MSLiveSchedule = structuredClone(this._MsLiveSchedule);
            schedule.msScheduleList = schedule.msScheduleList.filter((sc) => {
                if (this.baseStore.locale === AppLanguage.zh_hk) {
                    return sc.languageCode === 'hk';
                } else {
                    return sc.languageCode === 'en';
                }
            });
            return schedule;
        }
        return null;
    }

    get preference() {
        return this.storageData?.preferenceData;
    }

    get wid() {
        return this.storageData?.wid;
    }

    private _calendarEventUUIDList: string[] = [];
    public get calendarEventUUIDList(): readonly string[] | any {
        return this._calendarEventUUIDList.length > 0
            ? this._calendarEventUUIDList
            : this.storageData?.calendarEventUUIDList
            ? this.storageData?.calendarEventUUIDList
            : [];
    }

    public set calendarEventUUIDList(v: readonly string[]) {
        this._calendarEventUUIDList = Array.isArray(v) ? [...v] : [];
    }

    // private _allBettingStrategies = false;
    // public get allBettingStrategies(): boolean {
    //     return this._allBettingStrategies;
    // }
    // public set allBettingStrategies(v: boolean) {
    //     this._allBettingStrategies = v;
    // }
    /** WA */
    get localSetting(): DeepReadonly<SendPreferenceCRMData> {
        const preferenceReData: any = {
            step1: undefined,
            step2: undefined,
            Horses: undefined,
            Trainers: undefined,
            Jockeys: undefined,
            Music: undefined,
            'Personal Interests': undefined,
            'Dinning Preference': undefined,
            notFirstTimePreference: undefined,
            newUser: undefined,
            steps: undefined,
            latestTrackTime: undefined,
        };
        return this.storageData?.preferenceData || preferenceReData;
    }

    /** WA */
    public saveLocalSetting(setting: SendPreferenceCRMData) {
        jsBridge.appSaveDiscoverPreference(setting as SendPreferenceCRMData);
        this.storageData = { ...this.storageData, preferenceData: setting };
        this.notFirstTimePreference = setting?.notFirstTimePreference || ['false'];
    }
}
